/* jshint esversion: 6 */
/* jshint esversion: 9 */
/* jshint ignore:start */
import { useCallback, useContext, useEffect, useRef, useState } from 'react';
import { MyContext } from '../../Context/MyProvider';
import axios from 'axios';
import Slider from "react-slick";
import { FaChevronRight } from "react-icons/fa6";
import { IoCartOutline, IoClose } from "react-icons/io5";
import { LuPlus, LuMinus, LuShoppingBag, LuChevronRight } from "react-icons/lu";
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { MdChevronLeft, MdChevronRight, MdOutlineMedicalServices } from 'react-icons/md';
import Loading from '../Loading';
import secureLocalStorage from "react-secure-storage";
import ImageLoad from '../ImageLoad';

const CustomPrevArrow = ({ onClick }) => (
    <div
        onClick={onClick}
        className="bg-[#4038FF] p-[3px] rounded-[50px] absolute z-10 right-[40px] -top-[30px] transform -translate-y-1/2 cursor-pointer hover:bg-indigo-700 transition-colors"
    >
        <MdChevronLeft color="#fff" size={22} />
    </div>
);

const CustomNextArrow = ({ onClick }) => (
    <div
        onClick={onClick}
        className="bg-[#4038FF] p-[3px] rounded-[50px] absolute z-10 right-[0px] -top-[30px] transform -translate-y-1/2 cursor-pointer hover:bg-indigo-700 transition-colors"
    >
        <MdChevronRight color="#fff" size={22} />
    </div>
);

const StoreHomePage = () => {

    const { t } = useTranslation();

    const { ApiBaseUrl, ImgBaseUrl, setIsLoginShow, selectproduct, setSelectProduct } = useContext(MyContext);
    const site_currency = secureLocalStorage.getItem("currency");
    const currency = site_currency ? site_currency : "$";

    const [bannerList, setbannerList] = useState([]);
    const [category, setCategory] = useState([]);
    const [selectId, setSelectId] = useState();
    const [productList, setproductList] = useState([]);
    const [detailsShow, setDetailsShow] = useState(false);
    const [detailsData, setDetailsData] = useState([]);
    const [isShow, setisShow] = useState("");
    const [details, setDetails] = useState([]);
    const [productId, setProductId] = useState();
    const [totalCart, setTotalCart] = useState(0);
    const [cartData, setCartData] = useState([]);
    const [loading, setLoading] = useState(true);
    const [apiloading, setApiLoading] = useState(false);
    const [detailslod, setDetailsLod] = useState(false);

    const LoadingRef = useRef(false);
    const LocalData = sessionStorage.getItem("Docdetails");

    if (LocalData) {
        var { Categoreyid, Docid } = JSON.parse(LocalData);
    }

    const settings = {
        dots: false,
        arrows: false,
        infinite: true,
        speed: 1000,
        slidesToShow: 3,
        slidesToScroll: 1,
        initialSlide: 0,
        autoplay: true,
        autoplaySpeed: 3000,
        responsive: [
            { breakpoint: 1200, settings: { slidesToShow: 2, slidesToScroll: 1, dots: true, centerMode: true } },
            { breakpoint: 1024, settings: { slidesToShow: 2, slidesToScroll: 1, dots: true, centerMode: true } },
            { breakpoint: 770, settings: { slidesToShow: 1, slidesToScroll: 1, centerMode: false } },
        ],
    };

    const Categories = {
        arrows: true,
        dots: false,
        infinite: false,
        speed: 1000,
        slidesToShow: 7,
        slidesToScroll: 1,
        initialSlide: 0,
        nextArrow: <CustomNextArrow />,
        prevArrow: <CustomPrevArrow />,
        responsive: [
            { breakpoint: 1145, settings: { slidesToShow: 6, slidesToScroll: 1 } },
            { breakpoint: 995, settings: { slidesToShow: 5, slidesToScroll: 1 } },
            { breakpoint: 580, settings: { slidesToShow: 4, slidesToScroll: 1 } },
            { breakpoint: 430, settings: { slidesToShow: 2, slidesToScroll: 1 } },
        ],
    };

    const settings2 = {
        arrows: false,
        dots: true,
        infinite: false,
        speed: 1000,
        slidesToShow: 1,
        slidesToScroll: 1,
    };

    const HandleProductListGet = useCallback((category_id) => {
        setSelectId(category_id);
        const Userid = secureLocalStorage.getItem("Userid") || "0";
        if (Userid) {
            axios.post(`${ApiBaseUrl}/customer/sub_product_list`, { uid: Userid, doctor_id: Docid, category_id })
                .then((res) => {
                    const { tot_cart_qty, product_list } = res.data;
                    setApiLoading(false);
                    setTotalCart(tot_cart_qty);
                    setproductList(product_list);
                })
                .catch((error) => {
                    console.error(error);
                });
        }
    }, [ApiBaseUrl, Docid]);

    const HandleDetailsGet = useCallback((id) => {
        const Userid = secureLocalStorage.getItem("Userid") || "0";
        setDetailsLod(true);
        setDetailsShow(true);

        if (Userid) {
            axios.post(`${ApiBaseUrl}/customer/product_detail`, { uid: Userid, doctor_id: Docid, prod_id: id })
                .then((res) => {
                    setDetailsData([res.data.product]);
                    setDetailsLod(false);
                    setSelectProduct("");
                })
                .catch((error) => {
                    console.error(error);
                });
        }
    }, [ApiBaseUrl, Docid, setSelectProduct]);

    useEffect(() => {
        window.scrollTo(0, 0);

        const Userid = secureLocalStorage.getItem("Userid") || "0";

        if (Userid) {
            axios.post(`${ApiBaseUrl}/customer/sub_category_list`, { uid: Userid, doctor_id: Docid, category_id: Categoreyid })
                .then((res) => {
                    if (res.data.ResponseCode === 200) {
                        setLoading(false);
                        setbannerList(res.data.banner_list);
                        setCategory(res.data.sub_category);
                        if (res.data.sub_category && res.data.sub_category.length > 0) {
                            HandleProductListGet(res.data.sub_category[0].id);
                        }
                    }
                })
                .catch((error) => {
                    console.error(error);
                });
        }
    }, [LocalData, ApiBaseUrl, Docid, Categoreyid, HandleProductListGet]);

    useEffect(() => {
        if (!selectproduct) return;
        HandleDetailsGet(selectproduct);
    }, [selectproduct, HandleDetailsGet]);

    const HandleShowPriceDetails = (e, items, index) => {
        e.stopPropagation();
        setDetailsShow(false);
        setProductId(items.id);
        setisShow({ name: items.product_name, img: index === 1 ? items.product_image[0] : items.product_image });
        setDetails(items.price_detail);
        const Data = { id: items.id, price_detail: items.price_detail };
        setCartData([...cartData, Data]);
    };

    useEffect(() => {
        loading
            ? document.body.style.overflow = "hidden"
            : document.body.style.overflow = "auto";
    }, [loading]);

    const HandleSelectCategoris = (id) => {
        setApiLoading(true);
        HandleProductListGet(id);
    }

    return (
        <div className='pb-[50px] w-full width-container content-wrapper store-page px-4 md:px-6 max-w-7xl mx-auto'>
            {loading ? (
                <Loading CustomeStyle="fixed left-0 top-0 h-[100vh] w-full flex items-center justify-center bg-white z-[9999]" />
            ) : (
                <div className="flex flex-col">
                    {/* Banners Carousel */}
                    <div className="slider-container mt-[20px]">
                        <Slider {...settings}>
                            {bannerList.map((item, index) => {
                                return (
                                    <div key={index} className="outline-none py-1">
                                        <ImageLoad 
                                            src={ImgBaseUrl + item} 
                                            CustomeStyle={"h-[220px] max-_430_:h-[200px] object-cover w-[100%] px-1 rounded-3xl shadow-sm border border-slate-100"} 
                                            alt={"Slider Img"} 
                                        />
                                    </div>
                                );
                            })}
                        </Slider>
                    </div>

                    <div className="flex flex-col">
                        <div className="mt-8">
                            <h2 className="text-xl font-bold text-slate-800 tracking-tight mb-4">{t("Categories")}</h2>
                            <div className="relative pt-2">
                                <Slider {...Categories}>
                                    {category.map((item, index) => {
                                        const [firstWord, ...restWords] = item.name.split(" ");
                                        const secondLine = restWords.join(" ");
                                        const isActive = selectId === item.id;
                                        return (
                                            <div
                                                onClick={() => HandleSelectCategoris(item.id)}
                                                key={index}
                                                className={`group h-[180px] w-[120px] mx-auto !flex flex-col items-center my-2 justify-between cursor-pointer rounded-2xl p-4 border transition-all duration-300 outline-none hover:-translate-y-1 hover:shadow-md ${isActive ? "border-indigo-600 bg-indigo-50/50 shadow-sm" : "border-slate-150 bg-white hover:border-indigo-300"}`}
                                            >
                                                <div className="flex items-center justify-center w-20 h-20 bg-slate-50 group-hover:bg-indigo-50 rounded-full transition-colors duration-300 shadow-inner">
                                                    <ImageLoad src={ImgBaseUrl + item.image} CustomeStyle={"h-12 w-12 object-contain group-hover:scale-110 transition-transform duration-300 block"} alt={item.name} />
                                                </div>

                                                <div className="text-center mt-3 leading-tight w-full">
                                                    <h3 className={`text-xs font-semibold ${isActive ? "text-indigo-600" : "text-slate-700 group-hover:text-indigo-600 transition-colors duration-200"}`}>{firstWord}</h3>
                                                    <h3 className={`text-xs font-semibold whitespace-nowrap overflow-hidden overflow-ellipsis w-full ${isActive ? "text-indigo-600" : "text-slate-700 group-hover:text-indigo-600 transition-colors duration-200"}`}>{secondLine}</h3>
                                                </div>
                                            </div>
                                        );
                                    })}
                                </Slider>
                            </div>
                        </div>

                        {/* Product Grid list */}
                        <div className="mt-10">
                            <h2 className="text-2xl font-bold text-slate-800 tracking-tight mb-6">{t("Bestseller Products")}</h2>

                            {apiloading ? (
                                <Loading CustomeStyle="w-full h-[300px] flex items-center justify-center" />
                            ) : productList?.length >= 1 ? (
                                <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-6 mt-4">
                                    {productList.map((item, index) => {
                                        const totalCartQty = item.price_detail.reduce((acc, curr) => acc + curr.cart_qty, 0);
                                        const priceInfo = item.price_detail[0];

                                        return (
                                            <div
                                                key={index}
                                                onClick={() => HandleDetailsGet(item.id)}
                                                className="group bg-white rounded-3xl border border-slate-150 hover:border-indigo-500/20 overflow-hidden cursor-pointer shadow-sm hover:shadow-md hover:-translate-y-1.5 transition-all duration-350 flex flex-col justify-between"
                                            >
                                                {/* Image and discount tag */}
                                                <div className="relative h-48 md:h-52 overflow-hidden bg-slate-50 flex items-center justify-center p-4">
                                                    <ImageLoad 
                                                        src={ImgBaseUrl + item.product_image} 
                                                        CustomeStyle={"w-full h-full object-contain transition-transform duration-500 group-hover:scale-105"} 
                                                        alt={item.product_name} 
                                                    />
                                                    {priceInfo.discount !== 0 && (
                                                        <div className="absolute top-3 left-0 bg-orange-500 text-white text-xs font-semibold py-1 px-3 rounded-r-full shadow-sm">
                                                            {priceInfo.discount}% OFF
                                                        </div>
                                                    )}
                                                </div>

                                                {/* Text detail metadata */}
                                                <div className="p-5 flex-1 flex flex-col justify-between">
                                                    <div>
                                                        <h3 className="font-bold text-slate-800 text-[16px] group-hover:text-indigo-600 transition-colors duration-200 line-clamp-1 mb-1.5 w-full">
                                                            {item.product_name}
                                                        </h3>
                                                        <div className="flex items-baseline gap-2 mt-1">
                                                            <span className="font-bold text-slate-900 text-lg">{currency}{priceInfo.price}</span>
                                                            {priceInfo.base_price && priceInfo.base_price !== priceInfo.price && (
                                                                <span className="line-through text-slate-400 text-sm">{currency}{priceInfo.base_price}</span>
                                                            )}
                                                        </div>
                                                    </div>

                                                    {/* Quantity and option highlights */}
                                                    <div className="mt-4 pt-3 border-t border-slate-100 flex items-center justify-between gap-3">
                                                        <span className="text-slate-400 text-xs font-semibold">{item.price_detail.length} {item.price_detail.length === 1 ? t("Option") : t("Options")}</span>
                                                        
                                                        <div className="flex justify-end">
                                                            <button
                                                                onClick={(e) => HandleShowPriceDetails(e, item)}
                                                                className={`flex items-center justify-center min-w-[80px] h-9 border transition-all duration-200 rounded-full font-medium ${totalCartQty ? 'bg-indigo-50 border-indigo-200 text-indigo-700' : 'bg-indigo-600 border-indigo-600 hover:bg-indigo-700 text-white shadow-sm hover:shadow'}`}
                                                            >
                                                                {totalCartQty ? (
                                                                    <div className="flex items-center justify-between w-full px-2.5 gap-1.5">
                                                                        <span className="text-xs font-bold leading-none">{totalCartQty}</span>
                                                                        <LuChevronRight className="w-3 h-3 text-indigo-600" />
                                                                    </div>
                                                                ) : (
                                                                    <span className="text-xs font-bold px-3 tracking-wide uppercase">{t("Add")}</span>
                                                                )}
                                                            </button>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        );
                                    })}
                                </div>
                            ) : (
                                <div className="col-span-full bg-slate-50 rounded-3xl p-10 flex flex-col items-center justify-center text-center border border-dashed border-slate-200/80">
                                    <h3 className="font-bold text-slate-800 text-lg">{t("No Products Available")}</h3>
                                    <p className="text-slate-500 text-sm max-w-xs mt-1">
                                        {t("No store products were found matching this category.")}
                                    </p>
                                </div>
                            )}
                        </div>
                    </div>
                </div>
            )}

            {/* Centered Product Details Modal */}
            {detailsShow && (
                <div 
                    onClick={() => setDetailsShow(false)} 
                    className="flex bg-slate-900/60 backdrop-blur-sm h-full justify-center w-full fixed items-center left-0 top-0 z-[999] p-4"
                >
                    <div 
                        onClick={(e) => e.stopPropagation()} 
                        className="bg-white rounded-[24px] shadow-2xl max-w-3xl w-full max-h-[90vh] overflow-y-auto scroll-container p-5 md:p-8 relative"
                    >
                        {/* Close Button */}
                        <button 
                            onClick={() => setDetailsShow(false)}
                            className="absolute top-4 right-4 p-2 rounded-full text-slate-400 hover:text-slate-600 hover:bg-slate-100 transition-all duration-200 z-20"
                            aria-label="Close modal"
                        >
                            <IoClose className="w-6 h-6" />
                        </button>

                        {detailslod ? (
                            <div className="w-full h-[400px] flex flex-col items-center justify-center gap-3">
                                <div className="loader2"></div>
                                <span className="text-slate-500 font-medium text-sm">{t("Loading details...")}</span>
                            </div>
                        ) : (
                            <div className="mt-2">
                                {detailsData.map((item, index) => {
                                    const singleLineText = item?.description ? item.description.replace(/\r\n|\r|\n/g, '<br />') : '';
                                    const TotalCart = item.price_detail.reduce((acc, curr) => acc + curr.cart_qty, 0);
                                    return (
                                        <div key={index} className="grid grid-cols-1 md:grid-cols-2 gap-8">
                                            {/* Left Column: Image Slider */}
                                            <div className="flex flex-col justify-center">
                                                <div className="slider-container relative rounded-2xl overflow-hidden border border-slate-100 p-2 bg-slate-50">
                                                    <Slider {...settings2}>
                                                        {item.product_image.map((img, imgIdx) => {
                                                            return (
                                                                <div key={imgIdx} className="outline-none py-4">
                                                                    <ImageLoad 
                                                                        src={ImgBaseUrl + img} 
                                                                        CustomeStyle={"h-[240px] md:h-[280px] object-contain w-full rounded-xl mix-blend-multiply"} 
                                                                        alt={item.product_name} 
                                                                    />
                                                                </div>
                                                            );
                                                        })}
                                                    </Slider>
                                                </div>
                                            </div>
                                            
                                            {/* Right Column: Text Details */}
                                            <div className="flex flex-col justify-between">
                                                <div>
                                                    {/* Prescription Tag */}
                                                    {item.prescription_require === "Required" && (
                                                        <div className="inline-flex items-center gap-1.5 px-3 py-1 rounded-full text-xs font-semibold bg-rose-50 text-rose-600 border border-rose-100 mb-3">
                                                            <MdOutlineMedicalServices className="w-4 h-4 text-rose-500" />
                                                            <span>{t("Prescription Required")}</span>
                                                        </div>
                                                    )}
                                                    
                                                    <h1 className="font-bold text-slate-800 text-xl md:text-2xl leading-snug tracking-tight">
                                                        {item.product_name}
                                                    </h1>
                                                    
                                                    {/* Price information */}
                                                    <div className="flex items-baseline gap-2.5 mt-4 pb-4 border-b border-slate-100">
                                                        <span className="font-extrabold text-slate-900 text-2xl">
                                                            {currency}{item.price_detail[0].price}
                                                        </span>
                                                        {item.price_detail[0].base_price && item.price_detail[0].base_price !== item.price_detail[0].price && (
                                                            <span className="line-through text-slate-400 font-medium">
                                                                {currency}{item.price_detail[0].base_price}
                                                            </span>
                                                        )}
                                                        {item.price_detail[0].discount !== 0 && (
                                                            <span className="bg-orange-50 text-orange-600 border border-orange-100 px-2.5 py-0.5 rounded-full text-xs font-semibold">
                                                                {item.price_detail[0].discount}% OFF
                                                            </span>
                                                        )}
                                                    </div>
                                                    
                                                    {/* Overview Overview description */}
                                                    <div className="mt-5">
                                                        <h3 className="font-semibold text-slate-700 text-sm tracking-wider uppercase mb-2">{t("Product Overview")}</h3>
                                                        <div 
                                                            className="text-slate-500 text-sm leading-relaxed max-h-[150px] overflow-y-auto pr-2 scroll-container" 
                                                            dangerouslySetInnerHTML={{ __html: singleLineText }} 
                                                        />
                                                    </div>
                                                </div>
                                                
                                                {/* Action section footer */}
                                                <div className="mt-6 pt-4 border-t border-slate-100 flex items-center justify-between gap-4">
                                                    <div className="flex flex-col">
                                                        <span className="text-slate-400 text-xs font-semibold uppercase tracking-wider">{t("Unit Option")}</span>
                                                        <span className="text-slate-700 font-bold text-base mt-0.5">
                                                            {item.price_detail.length} {item.price_detail.length === 1 ? t("Option") : t("Options")}
                                                        </span>
                                                    </div>
                                                    
                                                    <button 
                                                        onClick={(e) => HandleShowPriceDetails(e, item, 1)} 
                                                        className={`flex items-center justify-center font-semibold px-6 py-3 rounded-full shadow-sm hover:shadow active:scale-95 transition-all duration-200 text-sm tracking-wide ${TotalCart ? 'bg-indigo-50 text-indigo-700 border border-indigo-200' : 'bg-indigo-600 text-white hover:bg-indigo-700'}`}
                                                    >
                                                        {TotalCart ? (
                                                            <span className="flex items-center gap-2">
                                                                <LuShoppingBag className="w-4 h-4" />
                                                                {TotalCart} {t("In Cart")}
                                                            </span>
                                                        ) : (
                                                            t("Select Options")
                                                        )}
                                                    </button>
                                                </div>
                                            </div>
                                        </div>
                                    );
                                })}
                            </div>
                        )}
                    </div>
                </div>
            )}

            {/* Centered Variant Selector Modal */}
            {isShow && (
                <div 
                    onClick={() => setisShow("")} 
                    className="flex bg-slate-900/60 backdrop-blur-sm h-full justify-center w-full fixed items-center left-0 top-0 z-[999] p-4"
                >
                    <div 
                        onClick={(e) => e.stopPropagation()} 
                        className="bg-white rounded-[24px] shadow-2xl max-w-lg w-full max-h-[85vh] flex flex-col p-6 relative"
                    >
                        {/* Close Button */}
                        <button 
                            onClick={() => setisShow("")}
                            className="absolute top-4 right-4 p-2 rounded-full text-slate-400 hover:text-slate-600 hover:bg-slate-100 transition-all duration-200 z-20"
                            aria-label="Close modal"
                        >
                            <IoClose className="w-5 h-5" />
                        </button>
                        
                        <div className="mb-4 pr-8">
                            <span className="text-xs font-semibold uppercase tracking-wider text-indigo-600 bg-indigo-50 px-2.5 py-1 rounded-md inline-block mb-1">{t("Select Variant")}</span>
                            <h1 className="font-bold text-slate-800 text-lg md:text-xl line-clamp-1">{isShow.name}</h1>
                        </div>

                        <div className="flex-1 overflow-y-auto scroll-container pr-1 py-1 max-h-[420px]">
                            {details.map((item, index) => {
                                return (
                                    <DetailsSheet 
                                        key={index} 
                                        item={item} 
                                        LoadingRef={LoadingRef} 
                                        index={index} 
                                        ImgBaseUrl={ImgBaseUrl} 
                                        ApiBaseUrl={ApiBaseUrl} 
                                        currency={currency} 
                                        isShow={isShow} 
                                        setisShow={setisShow} 
                                        setIsLoginShow={setIsLoginShow} 
                                        Docid={Docid} 
                                        productId={productId} 
                                        details={details} 
                                        productList={productList} 
                                        setDetails={setDetails} 
                                        setproductList={setproductList} 
                                        setTotalCart={setTotalCart} 
                                        totalCart={totalCart} 
                                    />
                                );
                            })}
                        </div>
                        
                        <div className="mt-6 pt-4 border-t border-slate-100">
                            <button 
                                onClick={() => setisShow("")} 
                                className="w-full bg-slate-900 hover:bg-slate-800 text-white font-semibold text-base rounded-full py-3.5 active:scale-[0.99] transition-all duration-200"
                            >
                                {t("Done")}
                            </button>
                        </div>
                    </div>
                </div>
            )}

            {/* Bottom floating Checkout panel */}
            {totalCart !== 0 && (
                <Link 
                    to="/checkout" 
                    className="w-full flex justify-center fixed items-end left-0 right-0 bottom-[15px] z-[888] px-4 animate-in slide-in-from-bottom duration-300"
                >
                    <div className="bg-indigo-600 hover:bg-indigo-700 text-white px-6 py-3 rounded-full flex items-center justify-between gap-6 transition-all duration-300 max-w-md w-full">
                        <div className="flex items-center gap-3">
                            <div className="bg-indigo-850 rounded-full p-2.5">
                                <IoCartOutline className='text-white text-xl' />
                            </div>
                            <div className="leading-tight text-start">
                                <h1 className='font-bold text-[16px]'>{t("View Cart")}</h1>
                                <span className='text-xs font-semibold text-indigo-200'>{totalCart} {totalCart === 1 ? t("Item") : t("Items")}</span>
                            </div>
                        </div>
                        <div className="flex items-center gap-1">
                            <span className="text-xs font-semibold tracking-wider uppercase">{t("Checkout")}</span>
                            <FaChevronRight className='text-white text-sm' />
                        </div>
                    </div>
                </Link>
            )}
        </div>
    )
}

export default StoreHomePage;
/* jshint ignore:end */

export const DetailsSheet = ({ item, index, ImgBaseUrl, LoadingRef, ApiBaseUrl, currency, isShow, setisShow, setIsLoginShow, Docid, productId, details, productList, setDetails, setproductList, setTotalCart, totalCart }) => {

    const { t } = useTranslation();

    const [loading, setLoading] = useState(false);

    const handleAddToCart = (item) => {

        const Userid = secureLocalStorage.getItem("Userid");

        if (LoadingRef.current) {
            return;
        }

        if (!Userid) {
            setisShow("");
            setIsLoginShow(true);
            return;
        }

        setLoading(true);
        LoadingRef.current = true;

        const payload = {
            uid: Userid,
            doctor_id: Docid,
            prod_id: productId,
            pro_price: item.price,
            pro_ptype: item.title,
            pro_qty: item.cart_qty,
            pro_qty_type: 1,
            mode: 1,
        };

        const updatedDetails = details.map(detail =>
            detail.title === item.title
                ? { ...detail, cart_qty: detail.cart_qty + 1 }
                : detail
        );

        const updatedProductList = productList.map(product =>
            product.id === productId
                ? { ...product, price_detail: updatedDetails }
                : product
        );

        axios.post(`${ApiBaseUrl}/customer/cart_detail`, payload)
            .then((response) => {
                setLoading(false);
                LoadingRef.current = false;
                setDetails(updatedDetails);
                setproductList(updatedProductList);
                setTotalCart(prevCount => prevCount + 1);
            })
            .catch((error) => {
                console.error('Failed to add item to cart:', error);
                setLoading(false);
                LoadingRef.current = false;
            });
    };

    const handleRemoveToCart = (item) => {
        const Userid = secureLocalStorage.getItem("Userid");

        if (LoadingRef.current) {
            return;
        }

        if (Userid) {

            setLoading(true);
            LoadingRef.current = true;

            const Data = {
                uid: Userid,
                doctor_id: Docid,
                prod_id: productId,
                pro_price: item.price,
                pro_ptype: item.title,
                pro_qty: item.cart_qty,
                pro_qty_type: 2,
                mode: 1
            };

            const updatedDetails = details.map(detail =>
                detail.title === item.title
                    ? { ...detail, cart_qty: detail.cart_qty - 1 }
                    : detail
            );

            const updatedProductList = productList.map(product =>
                product.id === productId
                    ? { ...product, price_detail: updatedDetails }
                    : product
            );

            axios.post(`${ApiBaseUrl}/customer/cart_detail`, Data)
                .then((res) => {
                    setLoading(false);
                    LoadingRef.current = false;
                    setDetails(updatedDetails);
                    setproductList(updatedProductList);
                    setTotalCart(totalCart - 1);
                })
                .catch((error) => {
                    console.error(error);
                    setLoading(false);
                    LoadingRef.current = false;
                });
        }
    };

    return (
        <div key={index} className="bg-slate-50 hover:bg-slate-100/60 border border-slate-100/80 rounded-2xl p-4 transition-all duration-200 shadow-sm flex flex-col sm:flex-row sm:items-center justify-between gap-4 mb-3">
            <div className="flex items-center gap-4">
                <div className="relative group overflow-hidden rounded-xl border border-slate-200/60 bg-white p-1">
                    <ImageLoad src={ImgBaseUrl + isShow.img} CustomeStyle={"w-[72px] h-[72px] object-contain rounded-lg transition-transform duration-300 group-hover:scale-105"} alt={"img"} />
                </div>
                <div className="leading-snug">
                    <h2 className='font-semibold text-slate-800 text-[16px]'>{isShow.name}</h2>
                    <span className='text-xs font-medium px-2 py-0.5 bg-slate-200/60 text-slate-600 rounded-md inline-block mt-1'>{item.title}</span>
                    <div className="flex items-baseline gap-2 mt-2">
                        <span className='font-bold text-slate-900 text-lg'>{currency}{item.price}</span>
                        {item.base_price && item.base_price !== item.price && (
                            <span className='line-through text-slate-400 text-sm'>{currency}{item.base_price}</span>
                        )}
                        {item.discount !== 0 && (
                            <span className='bg-orange-50 text-orange-600 border border-orange-100 px-2 py-0.5 rounded-full text-xs font-semibold ml-1.5'>
                                {item.discount}% OFF
                            </span>
                        )}
                    </div>
                </div>
            </div>
            <div className="flex justify-end sm:justify-start">
                <div className={`flex items-center justify-center min-w-[100px] h-10 border transition-all duration-200 rounded-full font-medium ${item.cart_qty ? 'bg-indigo-50 border-indigo-200 text-indigo-700' : 'bg-indigo-600 border-indigo-600 hover:bg-indigo-700 text-white shadow-sm hover:shadow'}`}>
                    {loading ? (
                        <div className="px-5 py-2">
                            <div className="loader2 mx-auto"></div>
                        </div>
                    ) : item.cart_qty ? (
                        <div className="flex items-center justify-between w-full px-2 gap-3">
                            <button 
                                onClick={() => handleRemoveToCart(item)}
                                className="w-7 h-7 flex items-center justify-center rounded-full hover:bg-indigo-200/50 text-indigo-700 active:scale-90 transition-all duration-150"
                                aria-label="Decrease quantity"
                            >
                                <LuMinus className="w-4 h-4" />
                            </button>
                            <span className="font-semibold text-base select-none">{item.cart_qty}</span>
                            <button 
                                onClick={() => handleAddToCart(item)}
                                className="w-7 h-7 flex items-center justify-center rounded-full hover:bg-indigo-200/50 text-indigo-700 active:scale-90 transition-all duration-150"
                                aria-label="Increase quantity"
                            >
                                <LuPlus className="w-4 h-4" />
                            </button>
                        </div>
                    ) : (
                        <button 
                            onClick={() => handleAddToCart(item)} 
                            className="w-full h-full text-center text-sm font-semibold tracking-wide uppercase px-5"
                        >
                            {t("Add")}
                        </button>
                    )}
                </div>
            </div>
        </div>
    );
}